import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ThemeToggle } from "../components/ThemeToggle";
function BrushNodeLogo() {
  return <div className="w-24 h-24 relative" data-id="element-318">
      <div className="absolute inset-0" data-id="element-319">
        <div className="w-full h-full bg-[#2563eb] rounded-full" data-id="element-320" />
      </div>
      <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-321">
        <circle cx="50" cy="50" r="46" fill="none" stroke="white" strokeWidth="2" strokeOpacity="0.9" strokeLinecap="round" strokeDasharray="0.1 4" data-id="element-322" />
        <circle cx="50" cy="50" r="6" stroke="white" strokeWidth="2" fill="none" fillOpacity="0.9" data-id="element-323" />
        {[30, 150, 270].map(angle => <g key={angle} transform={`rotate(${angle} 50 50)`} data-id="element-324">
            <line x1="50" y1="50" x2="50" y2="25" stroke="white" strokeWidth="2" strokeOpacity="0.9" data-id="element-325" />
            <circle cx="50" cy="25" r="4" fill="white" fillOpacity="0.9" data-id="element-326" />
          </g>)}
      </svg>
    </div>;
}
const logos = [{
  component: BrushNodeLogo,
  name: "Network Node",
  description: "Connected nodes in a brushstroke circle"
}];
export function LogoGallery() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white dark:from-gray-900 dark:to-gray-800" data-id="element-327">
      <nav className="fixed top-0 w-full bg-white dark:bg-gray-900 border-b dark:border-gray-700 z-50" data-id="element-328">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-329">
          <div className="flex items-center justify-between h-16" data-id="element-330">
            <button onClick={() => navigate("/")} className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors flex items-center" data-id="element-331">
              <ArrowLeft className="w-5 h-5 mr-2" data-id="element-332" />
              Back to Home
            </button>
            <div className="flex items-center space-x-4" data-id="element-333">
              <ThemeToggle data-id="element-334" />
              <div onClick={() => navigate("/")} className="text-xl font-bold text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-700 dark:hover:text-blue-300 transition-colors" data-id="element-335">
                <span data-id="element-336">MVP</span>
                <span data-id="element-337">Hub.co</span>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <main className="pt-32 pb-24" data-id="element-338">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-339">
          <div className="text-center mb-16" data-id="element-340">
            <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-341">
              Logo Variation
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-400" data-id="element-342">
              Network node interpretation of our brand identity
            </p>
          </div>
          <div className="flex justify-center" data-id="element-343">
            <div className="flex flex-col items-center" data-id="element-344">
              <div className="bg-white dark:bg-gray-800 p-12 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100 dark:border-gray-700" data-id="element-345">
                <div className="w-24 h-24" data-id="element-346">
                  <BrushNodeLogo data-id="element-347" />
                </div>
              </div>
              <h3 className="mt-6 text-xl font-semibold text-gray-900 dark:text-white" data-id="element-348">
                Network Node
              </h3>
              <p className="mt-2 text-sm text-gray-600 dark:text-gray-400 text-center" data-id="element-349">
                Connected nodes in a brushstroke circle
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>;
}